<div [formGroup]="form">
  <h1 class="title">
    Votre adresse et disponibilité
  </h1>
  <h5 class="title-text-muted text-muted fs-16">
    Ces informations nous permettront de vous proposer des missions adaptées à votre localisation.
  </h5>

  <div class="row">
    <div class="col-8" style="margin-top: -6px;">
      <label class="form-label fw-bold text-black fs-14">Adresse <span class="text-danger">*</span></label>
      <input style="height: 45px;" type="text" class="form-control" autocomplete="off" formControlName="address"
        (input)="autoCompleteOnChange($event)" [matAutocomplete]="auto" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of addressList" [value]="getAdresseFormated(option)"
          (onSelectionChange)="addressSelected(option)">
          {{ getAdresseFormated(option) }}
        </mat-option>
      </mat-autocomplete>
      <div class="text-danger mt-1" *ngIf="form.get('address')?.touched && form.get('address')?.invalid">
        Veuillez saisir une adresse valide de la liste (En France)
      </div>
    </div>
    <div class="col-4">
      <app-custom-input 
        [parentForm]="form" 
        controlName="postalcode" 
        [label]="'Code postal'"
        [required]="true" 
        [type]="'number'" 
        [placeholder]="'0'">
      </app-custom-input>
    </div>
  </div>

  <div class="row mt-px-16">
    <div class="col-8">
      <app-custom-input 
        [parentForm]="form" 
        controlName="city" 
        [label]="'Ville'" 
        [required]="true">
      </app-custom-input>
    </div>
    <div class="col-4">
      <app-custom-input 
        [parentForm]="form" 
        controlName="country" 
        [label]="'Pays'" 
        [required]="true"
        [value]="'France'" 
        readonly>
      </app-custom-input>
    </div>
  </div>

  <div class="mt-px-32">
    <h5 class="mb-px-16">Votre disponibilité</h5>
    <div class="row">
      <div class="col-6">
        <app-custom-drop-down 
          [parentForm]="form" 
          controlName="disponibilite" 
          [label]="'Disponibilité'"
          [options]="disponibilityOptions" 
          [required]="true" 
          [simpleDropDown]="true">
        </app-custom-drop-down>
      </div>
      <div class="col-6">
        <app-custom-drop-down 
          [parentForm]="form" 
          controlName="disponibilitedate" 
          [label]="'À partir de'"
          [options]="disponibilityDateOptions" 
          [required]="true" 
          [simpleDropDown]="true">
        </app-custom-drop-down>
      </div>
    </div>
  </div>

  <div class="mt-px-32">
    <h5 class="mb-px-16">Votre zone de mobilité</h5>
    <div class="row">
      <div class="col-6">
        <app-custom-drop-down 
          [parentForm]="form" 
          controlName="mobilite" 
          [label]="'Zone de mobilité'"
          [options]="mobilityOptions" 
          [required]="true" 
          [simpleDropDown]="true">
        </app-custom-drop-down>
      </div>
      <div class="col-6">
        <app-custom-drop-down 
          [parentForm]="form" 
          controlName="transport" 
          [label]="'Mode de transport'"
          [options]="transportOptions" 
          [required]="true" 
          [simpleDropDown]="true">
        </app-custom-drop-down>
      </div>
    </div>
  </div>
</div>
